export const RecruitmentHubRoutes = {
    "/recruitment-hub/applicants?job_id&job_pos_cat_code&bucket_id&app_id&single&brand_id&hide_images": {
        "name": "appLayout.harriSH.access-portal.applicants",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            job_id: {dynamic: true},
            job_pos_cat_code: {dynamic: true},
            bucket_id: {dynamic: true},
            app_id: {dynamic: true},
            brand_id: {dynamic: true},
            single: {dynamic: true},
            hide_images: {dynamic: true}
        },
        "component": "hmapMyJobsPage",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["hmap_my_jobs", "rejection_templates"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Applicants"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../modules/hmap/my_jobs/hmap-my-jobs.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/recruitment-hub/recruitment-hub.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/chemistry-assessment/chemistry-assessment.module.js");
                }
            }
        ]
    },
    "/recruitment-hub/upload-candidates": {
        "name": "appLayout.harriSH.access-portal.upload-candidates",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {},
        "component": "hmapMyJobsPage",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["hmap_my_jobs"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Upload candidates"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../modules/hmap/my_jobs/hmap-my-jobs.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/recruitment-hub/recruitment-hub.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/wotc/wotc.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/on-boarding/on-boarding.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/pos-integration/pos-integration.module.js");
                }
            },
        ]
    }
};